import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from './components/layout.jsx';
import MainPage from './pages/main_page.jsx';
import Finance from './pages/finance.jsx';
import Translation from './pages/translation.jsx';
import GDPR from './pages/gdpr.jsx';
import './App.css';

function App() {
  return (
    <Router>
      <Layout >
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/translation" element={<Translation />} />
        <Route path="/gdpr" element={<GDPR />} />
      </Routes>
    </Layout>
    </Router>
  );
}

export default App;
